<template>
	<div>
		<el-dialog
			:title="`${scene === 'add' ? '添加' : '修改'}洗车费`"
			width="700px"
			v-model="data.visible"
			@close="handleCancle"
		>
			<el-form label-width="90px">
				<el-form-item label="时间">
					<el-time-picker
						is-range
						v-model="data.timeVal"
						range-separator="至"
						start-placeholder="开始时间"
						end-placeholder="结束时间"
						placeholder="选择时间范围"
						format="HH"
						value-format="HH"
						clearable
						@change="handleTimeChange"
					>
					</el-time-picker>
					<!-- data.formLabelAlign.startHour   endHour-->
				</el-form-item>
				<el-form-item label="洗车费">
					<el-input
						type="number"
						v-model="data.formLabelAlign.fee"
						placeholder="请输入洗车费"
					></el-input>
				</el-form-item>
				<el-form-item label="MPV洗车费">
					<el-input
						type="number"
						v-model="data.formLabelAlign.mpvFee"
						placeholder="请输入MPV洗车费"
					></el-input>
				</el-form-item>
				<el-form-item label="奖励金额">
					<el-input
						type="number"
						v-model="data.formLabelAlign.rewardAmount"
						placeholder="请输入奖励金额"
					></el-input>
				</el-form-item>
				<el-form-item label="SUV洗车费">
					<el-input
						type="number"
						v-model="data.formLabelAlign.suvFee"
						placeholder="请输入SUV洗车费"
					></el-input>
				</el-form-item>
			</el-form>
			<footer class="tac" style="margin-top: 50px">
				<el-button @click="handleCancle">取消</el-button>
				<el-button type="primary" @click="handleSave">确定</el-button>
			</footer>
		</el-dialog>
	</div>
</template>

<script>
import { inject, onMounted, reactive } from "vue";
import { apiCarWashFeeInsertAndUpdate } from "@/api/requestApis.js";
export default {
	props: {
		toggle: {
			type: Boolean,
			default: false,
		},
		scene: {
			type: String,
			default: "add",
		},
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props, context) {
		const handleSearch = inject("handleSearch");
		const data = reactive({
			visible: true,
			timeVal: "",
			formLabelAlign: {
				startHour: "",
				endHour: "",
				fee: "",
				mpvFee: "",
				rewardAmount: "",
				suvFee: "",
			},
		});
		const handleCancle = () => {
			context.emit("update:toggle", false);
		};
		const handleSave = async () => {
			await apiCarWashFeeInsertAndUpdate(
				{
					feeId:
						props.scene === "edit" ? props.currentData.feeId : null,
					...data.formLabelAlign,
				},
				props.scene === "add" ? "insert" : "update"
			);
			handleSearch();
			handleCancle();
		};
		const handleTimeChange = (val) => {
			if (val) {
				data.formLabelAlign.startHour = val[0];
				data.formLabelAlign.endHour = val[1];
			} else {
				data.formLabelAlign.startHour = "";
				data.formLabelAlign.endHour = "";
			}
		};
		onMounted(() => {
			if (props.scene === "edit") {
				data.timeVal = [
					props.currentData.startHour + ":00",
					props.currentData.endHour + ":00",
				];
				data.formLabelAlign.startHour = props.currentData.startHour;
				data.formLabelAlign.endHour = props.currentData.endHour;
				data.formLabelAlign.fee = props.currentData.fee;
				data.formLabelAlign.mpvFee = props.currentData.mpvFee;
				data.formLabelAlign.rewardAmount =
					props.currentData.rewardAmount;
				data.formLabelAlign.suvFee = props.currentData.suvFee;
			}
		});
		return {
			handleTimeChange,
			handleCancle,
			handleSave,
			data,
		};
	},
};
</script>

<style scoped>
</style>
